import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ElementDirective } from '@any2any/shared';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { NgxScannerQrcodeComponent } from 'ngx-scanner-qrcode';
import { PageTitleDirective } from '../core/directives/page-title.directive';
import { Any2anyLogoComponent } from './any2any-logo/any2any-logo';
import { CardTitleComponent } from './card/card-title/card-title.component';
import { CardComponent } from './card/card.component';
import { CommonGridComponent } from './common-grid/common-grid.component';
import { GridContainerComponent } from './grid/grid-container/grid-container.component';
import { GridItemDirective } from './grid/grid-item/grid-item.directive';
import { IconComponent } from './icon/icon.component';
import { RowSeparatorComponent } from './layout/row-separator/row-separator.component';
import { StackSeparatorComponent } from './layout/stack-separator/stack-separator.component';
import { ModalContainerComponent } from './modals/modal-container/modal-container.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { QrcodeScannerComponent } from './qrcode-scanner/qrcode-scanner.component';
import { SpinnerComponent } from './spinner/spinner.component';

const SHARED_COMPONENTS = [
  GridContainerComponent,
  CardComponent,
  CardTitleComponent,
  IconComponent,
  StackSeparatorComponent,
  RowSeparatorComponent,
  QrcodeComponent,
  SpinnerComponent,
  QrcodeScannerComponent,
  ModalContainerComponent,
  CommonGridComponent,
];

const SHARED_DIRECTIVES = [
  GridItemDirective,
];

const STANDALONE_DIRECTIVES = [
  PageTitleDirective,
  ElementDirective
];

const SHARED_MODULES = [
  FontAwesomeModule,
  NgxScannerQrcodeComponent,

  QRCodeComponent,
];

@NgModule({
  declarations: [
    ...SHARED_COMPONENTS,
    ...SHARED_DIRECTIVES,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ...SHARED_MODULES,
    ...STANDALONE_DIRECTIVES,
    Any2anyLogoComponent,
  ],
  exports: [
    ...SHARED_COMPONENTS,
    ...SHARED_DIRECTIVES,
    ...STANDALONE_DIRECTIVES,
    ...SHARED_MODULES
  ]
})
export class SharedModule {
}
